import {
	APPLY_FILTER_FAIL,
	APPLY_FILTER_SUCCESS,
	CLEAR_FILTER_FAIL,
	CLEAR_FILTER_SUCCESS,
	REMOVE_FILTER_FAIL,
	REMOVE_FILTER_SUCCESS,
} from './types';

export const applyFilters = (filterId, params) => {
	return async (dispatch) => {
		try {
			var payload = {
				[filterId]: params,
			};
			dispatch(applyFiltersSuccess(payload));
		} catch (error) {
			dispatch(applyFiltersFail(error));
		}
	};
};

export const clearFilters = (filterId) => {
	return async (dispatch) => {
		try {
			var payload = {
				[filterId]: {},
			};

			console.log('clearFilters', filterId, payload);
			dispatch(clearFiltersSuccess(payload));
		} catch (error) {
			dispatch(clearFiltersFail(error));
		}
	};
};

export const removeFilter = (filterId, filter) => {
	return async (dispatch, getState) => {
		try {
			const state = getState();

			var payload = {
				[filterId]: {
					...state.filters[filterId],
				},
			};

			delete payload[filterId][filter];

			dispatch(removeFilterSuccess(payload));
		} catch (error) {
			dispatch(removeFilterFail(error));
		}
	};
};

const applyFiltersSuccess = (payload) => ({
	type: APPLY_FILTER_SUCCESS,
	payload,
});

const applyFiltersFail = (payload) => ({
	type: APPLY_FILTER_FAIL,
	payload,
});

const clearFiltersSuccess = (payload) => ({
	type: CLEAR_FILTER_SUCCESS,
	payload,
});

const clearFiltersFail = (payload) => ({
	type: CLEAR_FILTER_FAIL,
	payload,
});

const removeFilterSuccess = (payload) => ({
	type: REMOVE_FILTER_SUCCESS,
	payload,
});

const removeFilterFail = (payload) => ({
	type: REMOVE_FILTER_FAIL,
	payload,
});
